import { render, staticRenderFns } from "./tradeInProcess.vue?vue&type=template&id=e9d5fd50&scoped=true"
import script from "./tradeInProcess.vue?vue&type=script&lang=js"
export * from "./tradeInProcess.vue?vue&type=script&lang=js"
import style0 from "./tradeInProcess.vue?vue&type=style&index=0&id=e9d5fd50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d5fd50",
  null
  
)

export default component.exports